import {
  PROMO_APPLIED,
  PROMO_EXPIRES,
  PROMO_SOLDOUT,
  PROMO_CASINO,
  PROMO_ERROR,
} from 'components/TargetedOffers/Components/Banner';
import colors from 'styles/colors';
import fonts from 'styles/fonts';

export const getColorFont = (isMobile, bannerType) => {
  if (isMobile) {
    switch (bannerType) {
      case PROMO_CASINO:
        return colors.functional.black;
      case PROMO_SOLDOUT:
        return colors.functional.darkGrey;
      case PROMO_APPLIED:
      case PROMO_EXPIRES:
        return colors.primary.ice;
      case PROMO_ERROR:
        return colors.primary.ice;
    }
    return colors.primary.ice;
  } else {
    switch (bannerType) {
      case PROMO_CASINO:
        return colors.secondary.goldBold;
      case PROMO_SOLDOUT:
        return colors.functional.darkGold;
      case PROMO_APPLIED:
        return colors.functional.green;
      case PROMO_EXPIRES:
        return colors.secondary.magentaDeep;
      case PROMO_ERROR:
        return colors.functional.errorRed;
    }
  }
  return colors.primary.ice;
};

export const getFontFamily = (isMobile) => {
  if (isMobile) {
    return fonts.primary.regular;
  } 

  return fonts.primary.semibold;
};